export default __webpack_public_path__ + "static/media/icon-cancel-dark.f5bf0267.svg";